import { z } from "zod";
export const PageScreenshotInput = z.object({
    url: z.string().url(),
    elementSelector: z.string(),
    uploadUrl: z.string().url(),
    viewportSize: z
        .object({
        width: z.number().positive(),
        height: z.number().positive(),
    })
        .optional(),
    imageSize: z
        .object({
        width: z.number().positive(),
        height: z.number().positive(),
    })
        .optional(),
    supernovaAuth: z
        .object({
        accessToken: z.string(),
    })
        .optional(),
    trace: z
        .object({
        sentryTrace: z.string().optional(),
        baggage: z.string().optional(),
    })
        .optional(),
});
export const PageScreenshotOutput = z.discriminatedUnion("success", [
    z.object({
        success: z.literal(true),
        fileSize: z.number(),
    }),
    z.object({
        success: z.literal(false),
        error: z.string(),
    }),
]);
